var map = {
	"./assets/close-icon.png": 1523,
	"./assets/social/apple.png": 6679,
	"./assets/social/email.png": 1370,
	"./assets/social/facebook.png": 2692,
	"./assets/social/google.png": 1279,
	"./assets/social/twitter.png": 1532,
	"./assets/wallets/avalanche.png": 3296,
	"./assets/wallets/bsc.png": 7416,
	"./assets/wallets/okex.png": 9231,
	"./assets/wallets/terra.png": 6161,
	"./assets/wallets/wallet-connect.png": 1686,
	"./singlesignon": 5215,
	"./singlesignon.tsx": 5215,
	"components/singlesignon/assets/close-icon.png": 1523,
	"components/singlesignon/assets/social/apple.png": 6679,
	"components/singlesignon/assets/social/email.png": 1370,
	"components/singlesignon/assets/social/facebook.png": 2692,
	"components/singlesignon/assets/social/google.png": 1279,
	"components/singlesignon/assets/social/twitter.png": 1532,
	"components/singlesignon/assets/wallets/avalanche.png": 3296,
	"components/singlesignon/assets/wallets/bsc.png": 7416,
	"components/singlesignon/assets/wallets/okex.png": 9231,
	"components/singlesignon/assets/wallets/terra.png": 6161,
	"components/singlesignon/assets/wallets/wallet-connect.png": 1686,
	"components/singlesignon/singlesignon": 5215,
	"components/singlesignon/singlesignon.tsx": 5215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3418;